module.exports = __webpack_public_path__ + "media/images/menu/channel_3_off-c8a4eee68ddde2979418ebbf67f19ef4.jpg";